var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiImageSpark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    role: "img",
    "aria-label": "Pixel picture + sparkle",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pixel picture + sparkle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5h10v1H2v15h19V10h1v11h-1v1H2v-1H1V6h1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9h2v2H5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17h1v-1h1v-1h1v-1h1v-1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h-2v-1h-1v-1h-1v-1H9v-1H8v-1H7v1H6v1H5v1H4v1H3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16h1v-1h1v-1h1v1h1v1h1v1h1v1h-2v-1h-1v-1h-1v1h-1v1h-1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 1h1v2h1v1h2v1h-2v1h-1v2h-1V6h-1V5h-2V4h2V3h1Z M18 3v1h-1v1h1v1h1V5h1V4h-1V3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiImageSpark);
export default __webpack_public_path__ + "static/media/ai-image-spark.3678c22a72371509fb90e8e12d9808c0.svg";
export { ForwardRef as ReactComponent };